exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PostList1 .slide-header-a{color:inherit;text-decoration:none}.PostList1 .slide-header-a .fa{margin-left:.75em}.PostList1 .slide-h2{font-weight:400}.PostList1 .slide-item{border-bottom:1px solid #999}.PostList1 .slide-item:first-child{border-top:1px solid #999}.PostList1 .slide-thumbnail{width:100px;height:100px;max-width:100px;max-height:100px}.PostList1 .slide-thumbnail.no-image{background-color:#f9f9f9;color:#999}.PostList1 .slide-a{color:inherit;text-decoration:none}.PostList1 .slide-published{font-size:.9em;color:#666}.PostList1 .slide-title{font-weight:500;font-size:1.1em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/sass-loader/lib/loader.js!./src/components/contents/PostList1/PostList1.scss
// module id = 1055
// module chunks = 11